import { memo } from "react";

function CGR() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.4131 13C22.4258 13.0153 27.7981 19.4519 27.9883 22.5713C28.1627 25.4303 26.433 27.3577 24.1445 28C25.0844 26.5738 25.697 23.7452 23.2021 19.2441C23.2021 19.2441 22.9369 20.7844 20.5254 23.0742C19.2193 24.3143 19.0426 26.0297 19.4775 27.5078C18.104 26.7468 17.003 25.3134 17 22.8457C16.9954 19.1887 21.1952 18.5556 22.4131 13ZM27.7158 1.71582L1.71582 27.7158L0.28418 26.2842L26.2842 0.28418L27.7158 1.71582ZM5.5 0C5.5 0 11 6.38637 11 9.45117C10.9997 12.5158 8.5374 15 5.5 15C2.4626 15 0.000261317 12.5158 0 9.45117C0 6.38637 5.5 0 5.5 0ZM16.5215 4.13379C16.5293 4.1425 17.9995 5.78135 18 6.56934C18 7.35925 17.338 7.99996 16.5215 8C15.7049 7.99999 15.043 7.35926 15.043 6.56934C15.0434 5.782 16.5113 4.14519 16.5215 4.13379ZM12.4785 4.13086C12.4785 4.13086 13.957 5.77744 13.957 6.56738C13.9568 7.35709 13.2949 7.99702 12.4785 7.99707C11.6621 7.99707 11.0003 7.35712 11 6.56738C11 5.77744 12.4785 4.13086 12.4785 4.13086ZM14.4512 0C14.4641 0.0143719 15.9291 1.6489 15.9297 2.43555C15.9297 3.2254 15.2676 3.86608 14.4512 3.86621C13.6346 3.86621 12.9727 3.22548 12.9727 2.43555C12.9732 1.64542 14.4512 0 14.4512 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(CGR);
